import { useState, useEffect, useRef } from 'react'
import { useAuth } from '../contexts/auth'

export default function useLocation() {
  const [{ isAuthenticated, userDetails }] = useAuth()
  const [location, setLocation] = useState({})
  const [locationIsResolving, setLocationIsResolving] = useState(true)
  const mountedRef = useRef()

  useEffect(() => {
    mountedRef.current = true
    return () => (mountedRef.current = false)
  }, [])

  useEffect(() => {
    setLocationIsResolving(true)
    if (!isAuthenticated) {
      let navigator = window.navigator
      if (!navigator || !navigator.geolocation) return
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          if (mountedRef.current) {
            let geoLocationCoords = {
              lat: coords.latitude,
              lng: coords.longitude,
            }

            setLocation(geoLocationCoords)
            setLocationIsResolving(false)
          } else {
            setLocationIsResolving(false)
          }
        },
        (err) => {
          // user denied geolocation prompt, or some other error
          setLocationIsResolving(false)
          console.log('err', err)
        },
      )
    } else {
      const userDetailsLocation = userDetails?.location ?? {}
      userDetailsLocation.zipCode = userDetails?.zipCode

      setLocation(userDetailsLocation)
      setLocationIsResolving(false)
    }
  }, [isAuthenticated, userDetails?.location, userDetails?.zipCode])

  return [location, setLocation, locationIsResolving]
}
